// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/ActionsAction/Edit/Content/mutation-update.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Procedures_Content_Content_Procedure_ActionsAction_Edit_Content(
  $id: numeric!
  $procedure: vaxiom_procedures_set_input!
  $charges: [vaxiom_procedure_misc_fee_charge_templates_insert_input!]!
) {
  update_vaxiom_procedures_by_pk(pk_columns: { id: $id }, _set: $procedure) {
    id
  }
  delete_vaxiom_procedure_misc_fee_charge_templates(
    where: { procedure_id: { _eq: $id } }
  ) {
    affected_rows
  }
  insert_vaxiom_procedure_misc_fee_charge_templates(objects: $charges) {
    affected_rows
  }
}

`